export default __webpack_public_path__ + "static/media/ms-assign-search.6fffa52c.svg";